import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { SinSidebarLayout } from 'layouts/SinSidebarLayout';
import imgCheck from 'assets/images/ilustracion-check.svg';
import LinkComponent from 'components/design-system/Link/Link';
import { RUTAS } from 'const/Rutas';

export const MensajeSolicitudAprobada = () => {
  const codigoEmpresa = 0;

  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <div className="bg-white rounded shadow-md p-4 sm:p-8 relative mb-16 text-center justify-center">
        <img
          src={imgCheck}
          alt="Has aprobado la solicitud correctamente"
          className="mx-auto mb-6 h-40 md:h-80"
        />
        <Heading type="h2">
          Solicitud{' '}
          <span className="text-success-dark underline">Aprobada</span>
        </Heading>
        <Text size="M" className="mb-4 max-w-lg mx-auto">
          Has aprobado satisfactoriamente la solicitud de administración. Ahora
          el usuario autorizado podrá gestionar la información de tu negocio.
        </Text>
        <LinkComponent type="button" href={RUTAS.HOME_USER}>
          Ok, ir al inicio
        </LinkComponent>

        {/* <div className="border-2 border-gray-300 border-dotted rounded p-4 max-w-md mx-auto mt-8">
          <Text className="mb-4">
            Si te interesa ver más información con respecto a solicitudes de
            administración puedes ver el <strong>historial completo</strong>
          </Text>
          <LinkComponent
            type="button"
            href={`${RUTAS.NEGOCIO}/${codigoEmpresa}/solicitudes-administracion`}
          >
            Ver más solicitudes
          </LinkComponent>
        </div> */}
      </div>
    </SinSidebarLayout>
  );
};
